import { render } from "./UserFeed2.vue?vue&type=template&id=b0c3112a"
import script from "./UserFeed2.vue?vue&type=script&lang=js"
export * from "./UserFeed2.vue?vue&type=script&lang=js"

import "./UserFeed2.vue?vue&type=style&index=0&id=b0c3112a&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__